export function initScrollTop() {
    // Button erzeugen und einfügen
    const btn = document.createElement("button");
    btn.type = "button";
    btn.id = "scroll-top";
    btn.className = "scroll-top";
    btn.setAttribute("aria-label", "Nach oben scrollen");
    btn.innerHTML = `
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
            <path d="M12 5l-7 7h4v7h6v-7h4z" fill="currentColor"/>
        </svg>
    `;
    document.body.appendChild(btn);

    // Sichtbarkeit steuern
    window.addEventListener(
        "scroll",
        () => {
            btn.classList.toggle("is-visible", window.scrollY > 500);
        },
        { passive: true },
    );

    // Klick-Verhalten
    btn.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    });
}
